import { Component, Host, h, Prop, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';

@Component({
  tag: 'value-row',
  styleUrl: 'value-row.css',
  shadow: true,
})
export class ValueRow {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * The description
   */
  @Prop() description: string;

  /**
   * Text Orientation
   */
  @Prop() textOrientation: string;

  /**
   * Icons Orientation
   */
  @Prop() iconsOrientation: string;

  /**
   * Cards Data
   */
  @Prop() valueData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  componentDidLoad() {
    addIntersectionObserver(
      this.el.shadowRoot.querySelector('.value-row'),
      () => {
        this.el.shadowRoot.querySelector('.value-row').classList.add('animate');
      },
      ['.overlay0','.overlay1', '.overlay2', '.overlay3', '.overlay4', '.overlay5', '.overlay6'],
    );
  }

  
  render() {
    const cards = JSON.parse(this.valueData);
    //console.log('card', cards);
    return (
      <Host>
        <div class={`container value-row-container ${this.paddingBottom} ${this.paddingTop}`}>
          <div
            class={`value-row flex flex-col items-center justify-center layout-cards-${cards.length} ${this.textColor} ${this.backgroundColor} ${this.textOrientation}`}
            style={{ backgroundImage: `url(${this.backgroundImage})` }}
          >
            {(this.mainTitle || this.description) && (
              <div class={`value-row-top`}>
                {(this.mainTitle || this.description) && <div class={`overlay0`}></div>}
                {this.mainTitle && <h3 class={`value-row-top-title`}>{this.mainTitle}</h3>}
                {this.description && <div class={`value-row-top-description`} innerHTML={this.description}></div>}
              </div>
            )}
            <div class={`value-row-items`}>
              {cards.length > 0 &&
                cards &&
                cards.map((card, index) => (
                  <div class={`${this.iconsOrientation} value-row-item value-row-item-${cards.length}`}>
                    <div class={`overlay${index + 1}`}></div>
                    {this.assetType === 'image-layout' && card.image_url && (
                      <image-block imageClass="value-row-image" imageUrl={card.image_url} imageAlt={card.image_alt}></image-block>
                    )}
                    {this.assetType === 'icon-layout' && card.image_url && (
                      card.image_url.endsWith('.svg') ?
                        <div class="value-row-icon-masked" style={{
                          width: '64px',
                          height: '64px',
                          maskImage: `url(${card.image_url})`,
                          WebkitMaskImage: `url(${card.image_url})`, // For WebKit browsers
                        }}></div>
                        :
                        // <image-block imageClass="value-row-icon" imageUrl={card.image_url} imageAlt={card.image_alt}></image-block>
                        <img class={`value-row-icon`} src={card.image_url} alt={card.image_alt} loading="lazy" width='64' height='64' />
                    )}
                    {/* {this.assetType === 'icon-layout' && card.image_url && (
                      <image-block imageClass="value-row-icon" imageUrl={card.image_url} imageAlt={card.image_alt}></image-block>
                    )} */}
                    <div class={`value-row-item-content`}>
                      <h2 class={`value-row-item-content-title`}>{card.title}</h2>
                      <p class={`value-row-item-content-description`}>{card.description}</p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
